import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'; 
import { Formik, Field  } from 'formik'
import * as Yup from 'yup'

import { throttle, isMobile} from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import { postApiDatas, dayRemaining, strDateToFrLong, urlToHost } from "../../utilities/FrontFunctions/AoxFrontFunctions"
import { CONST_EventTypes } from "../../data/const"

import CustomSelect from '../../utilities/FrontFunctions/FormElements/CustomSelect'
import IconSVG from "../../utilities/FrontFunctions/IconSVG"

import ModalEventSession from './Modal/ModalEventSession';

class ObjEventDetail extends Component {

    constructor(props) {
        super(props);
      
        const { event, eventSessionId } = props;
        const sessions = event?.Sessions ?? [];
        const activeSession =
            sessions.find(s => String(s.EventSession_Id) === eventSessionId) ||
            sessions.find(s => s.EventRegistration_State && s.EventRegistration_State!=="ABSENT");
      
        this.state = {
          isMobile: isMobile(),
          activeSession,
          onRegistration: false,
          modalData:{
            isOpen: false,
            type:"",
            title: "",
            mainText: "",
            htmlContent: null
          }
        };
      
        this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this);
        this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200);
    }
      
	handleWindowResizeMainHeader() {
		this.setState({
			isMobile: isMobile()
		})
	}

    setActiveSession(id){
        const numericId = Number(id);
        this.setState({
            activeSession : this.props.event.Sessions.find(o => o.EventSession_Id === numericId)
        })
    }

    renderRulesContent = () => {
        const { event } = this.props
        const { activeSession } = this.state
        return ( <>
            {activeSession.EventSession_Rules && (
              <p className="t_main" dangerouslySetInnerHTML={{ __html: activeSession.EventSession_Rules }} />
            )}
    
            {event.Event_ShowRules && (<>
                {event.EventType_Code === 'JOUR' && (<>
                    <p className="t_title">Préparez-vous au mieux pour cette formation !</p>
                    <p className="t_main">
                      Pensez à apporter les bilans de l'année précédente et prenez un moment pour réfléchir à vos
                      attentes et vos objectifs pour cette session !
                    </p>
    
                    <p className="t_subtitle">
                      <strong>CONDITIONS D'INSCRIPTION</strong>
                    </p>
                    <ul>
                      <li>Places limitées à 20 personnes par journée.</li>
                      <li>Inscription limitée à une seule journée par thématique.</li>
                      <li>En cas d’empêchement, merci de penser à vous désinscrire pour ne pas être pénalisé dans vos
                        inscriptions futures .</li>
                    </ul>
    
                    <p className="t_subtitle">
                      <strong>CONDITIONS D'ACCÈS</strong>
                    </p>
                    <ul>
                      <li>Les portes ferment 30 minutes après l’heure d’accueil. Aucun accès après.</li>
                      <li>Accès réservé aux invités munis de convocation. Enfants non admis.</li>
                      <li>Formation non accessible aux non-officinaux.</li>
                    </ul>
    
                    <p className="t_subtitle">
                      <strong>PRÉSENCE</strong>
                    </p>
                    <ul>
                      <li>Présence requise pour toute la journée (ou les journées) pour recevoir les sacs produits.</li>
                    </ul>
                </>)}
    
                {event.EventType_Code === 'SOIR' && (<>
                    <p className="t_subtitle">
                      <strong>CONDITIONS D'INSCRIPTION</strong>
                    </p>
                    <ul>
                      <li>Places limitées pour chaque soirée.</li>
                      <li>En cas d’empêchement, merci de penser à vous désinscrire pour ne pas être pénalisé dans vos
                        inscriptions futures .</li>
                    </ul>
    
                    <p className="t_subtitle">
                      <strong>CONDITIONS D'ACCÈS</strong>
                    </p>
                    <ul>
                      <li>Les portes ferment à 21h15 précises. Aucun accès après.</li>
                      <li>Accès réservé aux invités avec invitation. Enfants non admis.</li>
                      <li>Formation non accessible aux non-officinaux.</li>
                    </ul>
    
                    <p className="t_subtitle">
                      <strong>PRÉSENCE</strong>
                    </p>
                    <ul>
                      <li>Les sacs produits seront distribués uniquement après la plénière.</li>
                    </ul>
                </>)}
            </>)}
        </>)
    }

    handleRegistration = (values) => {
        const { event } = this.props
        const { activeSession } = this.state

        // popin ShowRules intermédiaire avant inscription
        // ou avant popin liste d'attente
        if (event.Event_ShowRules || activeSession?.EventSession_Rules){
            //Popin intermédiaire ShowRules
            this.setState({
                modalData: {
                    type: 'rules',
                    title: null,
                    htmlContent: this.renderRulesContent(),
                    action: 'confirm',
                    onConfirm: () => {
                        if (activeSession?.EventSession_StateForRegistration==="FULL_CANWAITING") {
                            // Popin intermédiaire Liste d'attente
                            this.setState({
                                modalData: {
                                    type: 'waitingList',
                                    title: 'Votre demande a bien été prise en compte, malheureusement la session est pleine.',
                                    mainText: "Souhaitez-vous vous inscrire sur liste d’attente ?",
                                    action: 'yesno',
                                    onYes: () => {
                                    this.setState({ modalData: null }, () => this.registration(values, true))
                                    },
                                    onNo: () => this.setState({ modalData: null }),
                                },
                            })
                        } else {
                            this.setState({ modalData: null }, () => this.registration(values, false))
                        }
                    },
                    onClose: () => this.setState({ modalData: null }),
                },
            })
            return
        }

        // Popin intermédiaire Liste d'attente
        if (activeSession?.EventSession_StateForRegistration==="FULL_CANWAITING") {
            this.setState({
                modalData: {
                    type: 'waitingList',
                    title: 'Votre demande a bien été prise en compte, malheureusement la session est pleine.',
                    mainText: "Souhaitez-vous vous inscrire sur liste d’attente ?",
                    action: 'yesno',
                    onYes: () => { this.setState({ modalData: null }, () => this.registration(values, true)) },
                    onNo: () => this.setState({ modalData: null }),
                },
            })
            return
        }

        this.setState({ modalData: null }, () => this.registration(values, false))
    }

    registration = (values, isWaitingList) => {
        if (this.state.onRegistration) return

        this.setState({ onRegistration: true })
        document.body.classList.add('is-loading')

        const payload = { ...values, WaitingList: isWaitingList }

        postApiDatas(`/apiaox/Event/PostEventRegistration`, payload)
        .then((res) => {

            document.body.classList.remove('is-loading')
            this.setState({ onRegistration: false })

            if (res.IsValid) {
                const isUnregister = payload.Registration === false
                const title = isUnregister
                    ? isWaitingList
                        ? "Vous êtes désinscrit de la liste d’attente."
                        : "Votre désinscription a bien été prise en compte."
                    : isWaitingList
                        ? "Votre demande de liste d’attente a bien été prise en compte."
                        : "Votre inscription est enregistrée."

                this.setState({
                    modalData: {
                        type: 'success',
                        title,
                        mainText: isUnregister
                            ? ''
                            : isWaitingList
                                ? "Un mail vous sera envoyé avec votre convocation si une place se libère."
                                : "En cas d’empêchement, merci de penser à vous désinscrire pour ne pas être pénalisé.",
                        action: 'close',
                        className: 'popin_txt_medium',
                        onClose: () => window.location.reload(false),
                    },
                })
            }
            else {
                this.setState({
                    modalData: {
                        type:   res.Value?.Code === 'NOSHOW' ? 'noShow' 
                                : res.Value?.Code === 'FULL' ? 'full'
                                : res.Value?.Code === 'FULL_QUOTA' ? 'full'
                                : res.Value?.Code === 'QUOTA' ? 'full'
                                : res.Value?.Code === 'MAX_WAITING' ? 'full'
                                : res.Value?.Code === 'FULL_CANWAITING' ? 'full'
                                : 'error',
                        title: res.Value?.Titre || "Erreur lors de l'inscription",
                        mainText: res.Value?.Texte || res.Message || 'Une erreur est survenue.',
                        action: 'close',
                    },
                })
            }
        })
        .catch(() => {
            document.body.classList.remove('is-loading')    
            this.setState({
                modalData: {
                    type: 'error',
                    title: "Erreur lors de l'inscription",
                    mainText: 'Une erreur réseau est survenue.',
                    action: 'close',
                },
                onRegistration: false
            })
        })
    }

   	goReturn() {
        window.location.href =  urlToHost('/Accueil');
	}

    
	render() {
        const { activeSession, modalData, } = this.state;
        const { event, user, } = this.props;
		const DayRemaining = activeSession ? dayRemaining(activeSession.EventSession_StartDate) : -1;
        const ActiveState = event?.Sessions.length === 0 ? "NOSESSIONS"
                            : activeSession?.EventSession_Canceled ? "CANCELED"  
                            : activeSession?.EventRegistration_State === "ABSENT" ? "ABSENT"
                            : activeSession && DayRemaining < 0 ? "FINISHED" 
                            : activeSession?.EventRegistration_State === "ATTENTE" ? "WAITING"
                            : activeSession?.UserRegistered ? "REGISTERED"
                            : "OPEN";

		return (<>
            { event && 
                <div className={`obj_formation_detail
                    ${' ' + CONST_EventTypes[event.EventType_Code].css}
                    ${' ' + event.Brand.Brand_CssClass}
                    ${' ' + ActiveState === "CANCELED" ? "is_canceled" 
                            : ActiveState === "FINISHED" ? "is_finished"
                            : ActiveState === "WAITING" ? "is_waiting_list" 
                            : ActiveState === "REGISTERED" ? "is_registered" 
                            : ""
                    }
                `}>
                    <div className="ctn_row">
                        <div className="ctn_image">
                            <div className="ctn_visuel">
                                <img src={urlToHost(event.Event_MediaUrl)} alt={event.Event_MediaAlt}/>
                            </div>

                            <div className="ctn_logo">
                                <img src={urlToHost(event.Brand.Brand_LogoUrl)} alt={event.Brand.Brand_Name}/>
                            </div>
                        </div>

                        <div className="ctn_text">	
                            <p className={`t_tag`}>
                                {(activeSession && activeSession.EventSession_HalfDayTypeName !== "") ? "Demi-journée de formation" : event.EventType_Name}
                            </p>

                            {(ActiveState === "NOSESSIONS") ?
                                <div className="obj_notice">
                                    <div className="ctn_notice">
                                        <p className='t_title'>Evènement terminé</p>
                                        <p>Malheureusement, toutes les sessions sont terminées.<br/> Aucune nouvelle date n'a été annoncée pour le moment.</p>
                                        <div class="ctn_cta">
                                            <button class="obj_btn" onClick={this.goReturn}>retour</button>
                                        </div>
                                    </div>
                                </div>
                            :
                                <>
                                    {(ActiveState === "WAITING") && 
                                        <div className="obj_jours-restant">
                                            {DayRemaining === 0 ? "Aujourd'hui" : `J-${DayRemaining}`}
                                        </div>
                                    }

                                    {activeSession &&
                                        <ul className="list_infos">
                                            <li className="t_date">
                                                {activeSession.EventSession_EndDate != null
                                                    ? `Du ${strDateToFrLong(activeSession.EventSession_StartDate)} Au ${strDateToFrLong(activeSession.EventSession_EndDate)}`
                                                    : strDateToFrLong(activeSession.EventSession_StartDate)
                                                }
                                                {(activeSession.EventSession_HalfDayTypeName !== "") ? <><br/>{activeSession.EventSession_HalfDayTypeName}</> : ""}
                                            </li>
                                            
                                            <li className="t_info">
                                                {event.EventType_Code === 'WEB' 
                                                    ? activeSession.EventSession_StartHour ? activeSession.EventSession_StartHour : "-"
                                                    : activeSession.Place?.EventPlace_City ? activeSession.Place.EventPlace_City : "-"
                                                }
                                            </li>
                                        </ul>
                                    }

                                    {(ActiveState === "ABSENT") ? <p className="t_statut">Vous avez été absent à cette session.</p>
                                    : (ActiveState === "FINISHED") && activeSession?.EventRegistration_State === "PRESENT_2" ? <p className="t_statut">Merci pour votre participation.</p>
                                    : (ActiveState === "FINISHED") ? <p className="t_statut">Session terminée.</p>
                                    : (ActiveState === "WAITING") ? <p className="t_statut">Vous êtes inscrit en liste d'attente.</p>
                                    : (ActiveState === "REGISTERED") ? <p className="t_statut">Vous êtes inscrit.</p>
                                    : <></>}

                                    <p className="t_title">{(activeSession && activeSession.EventSession_SubTitle) ? activeSession.EventSession_SubTitle : event.Event_SubTitle}</p>
                                    <p className="t_desc" dangerouslySetInnerHTML={{__html: (activeSession && activeSession.EventSession_Description) ? activeSession.EventSession_Description : event.Event_Description}}/>

                                    {( (ActiveState === "REGISTERED" && (DayRemaining > -1)) || ActiveState === "WAITING" ) && <>
                                        <div className="obj_formation_detail_readonly">
                                            <p className="t_desc">En cas de changement, nous vous contacterons sur ce numéro.</p>
                                            <div className="obj_form">
                                                <input type="text" value={user.Phone} disabled/>
                                            </div>
                                        </div>

                                        <div className="ctn_cta">
                                            {(event.EventType_Code !== 'WEB'&& !(ActiveState === "WAITING")) &&
                                                <a className="obj_btn picto" href={activeSession.UrlConvocation} target="_blank" rel="noopener noreferrer">
                                                    <IconSVG icon="telecharger" width="23.595" height="20.227" />
                                                    télécharger votre convocation
                                                </a>
                                            }
                                            {(event.EventType_Code === 'WEB') && activeSession?.EventSession_WebLink &&
                                                <a className="obj_btn picto" href={activeSession.EventSession_WebLink} rel="noopener noreferrer">
                                                    participer
                                                </a>
                                            }   
                                            <button className="obj_btn light" 
                                                onClick={() => {
                                                    this.registration({
                                                        EventSession_Id:activeSession.EventSession_Id, 
                                                        Registration : false,
                                                        Phone : user.Phone,
                                                        WaitingList: (ActiveState === "WAITING")
                                                    });
                                                }}
                                            >
                                                se désinscrire {(ActiveState === "WAITING") && "de la liste d'attente"}
                                            </button>
                                        </div>

                                        {ActiveState === "REGISTERED" && activeSession.Place?.EventPlace_MediaUrl &&
                                            <div className="ctn_visuel_map">
                                                <img src={urlToHost(activeSession.Place.EventPlace_MediaUrl)} alt={activeSession.Place.EventPlace_MediaAlt}/>
                                            </div>
                                        }
                                    </>}

                                    {(ActiveState === "OPEN" || ActiveState === "ABSENT") && <>
                                        <Formik
                                            initialValues={{
                                                EventSession_Id: activeSession?.EventSession_Id,
                                                Registration : true,
                                                Phone : user.Phone
                                            }}
                                            validationSchema={
                                                Yup.object().shape({
                                                    EventSession_Id: Yup.string().required()
                                                    ,Phone: Yup.string().required()
                                                })
                                            }
                                            onSubmit={(values) => {
                                                values = {...values, WaitingList:(activeSession?.EventSession_StateForRegistration==="FULL_CANWAITING")}

                                                this.handleRegistration(values);
                                            }}
                                        >
                                            { ({ handleSubmit, setFieldValue, setFieldTouched, errors, touched, values }) => (
                                                <div className="obj_formation_detail_form">
                                                    <form onSubmit={handleSubmit}>
                                                        <div className="obj_form">
                                                            <label className="t_label">{activeSession ? "Autres dates disponibles :" : "Choisissez une date :"}</label>

                                                            <CustomSelect
                                                                fieldName={'EventSession_Id'}
                                                                placeholder={
                                                                    !activeSession 
                                                                    ? "Sélectionnez une date"
                                                                    : `${
                                                                        strDateToFrLong(activeSession.EventSession_StartDate)
                                                                    }${
                                                                        activeSession.EventSession_HalfDayTypeName !== "" ? " - " + activeSession.EventSession_HalfDayTypeName + " - " : ""
                                                                    }${(event.EventType_Code === 'WEB' 
                                                                        ? (activeSession.EventSession_StartHour && " à " + activeSession.EventSession_StartHour)
                                                                        : (activeSession.Place?.EventPlace_City && " à " + activeSession.Place.EventPlace_City)
                                                                    )}`
                                                                }
                                                                options={
                                                                    event.Sessions.map((session) => ({ 
                                                                        value: session.EventSession_Id, 
                                                                        label: `${
                                                                            strDateToFrLong(session.EventSession_StartDate)
                                                                        }${
                                                                            session.EventSession_HalfDayTypeName !== "" ? " - " + session.EventSession_HalfDayTypeName + " - " : ""
                                                                        }${(event.EventType_Code === 'WEB' 
                                                                            ? (session.EventSession_StartHour && " à " + session.EventSession_StartHour)
                                                                            : (session.Place?.EventPlace_City && " à " + session.Place.EventPlace_City)
                                                                        )}`
                                                                    }))
                                                                }
                                                                setFieldValue={setFieldValue}
                                                                setFieldTouched={setFieldTouched}
                                                                onChange={option => {this.setActiveSession(option.value);}}
                                                                errors={errors}
                                                                touched={touched}
                                                                values={values}
                                                                defaultValue={activeSession?.EventSession_Id}
                                                            />
                                                
                                                            <div className="ctn_phone">
                                                                <p className="t_desc">En cas de changement, nous vous contacterons sur ce numéro.</p>
                                                                <div className="ctn_row">
                                                                    <div className="ctn_input">
                                                                        <Field className={errors.Phone && touched.Phone && 'error'} as="input" type="text" name="Phone" placeholder="Téléphone personnel"/>
                                                                    </div>
                                                                    <p className="t_mandatory">Champ obligatoire</p>
                                                                </div>
                                                                <p className="t_info">Renseignez votre indicatif pays si vous habitez en dehors de la France.</p>
                                                            </div>

                                                            {activeSession && 
                                                                <div className="ctn_cta">
                                                                    <button className="obj_cta" type="submit">je m'inscris</button>
                                                                </div>
                                                            }

                                                            {( (touched.EventSession_Id && errors.EventSession_Id) ) && 
                                                                <p className="t_error mb_30 fade-in">Il y a des erreurs dans le formulaire.</p>
                                                            }

                                                            {this.state.apiError && 
                                                                <p className="t_error mb_30 fade-in"><br/>{this.state.apiErrorMsg}</p>
                                                            }
                                                        </div>
                                                    </form>
                                                </div>
                                            )}
                                        </Formik>
                                    </>}
                                </>
                            }
                        </div>

                        {modalData && (modalData.title || modalData.htmlContent || modalData.mainText) && (
                            <ModalEventSession
                                key={modalData.type + (modalData.title || '') + Date.now()} 
                                className={modalData.className || 'popin_txt_medium'}
                                isOpen={true}
                                titleText={modalData.title}
                                mainText={modalData.mainText}
                                htmlContent={modalData.htmlContent}
                                action={modalData.action}
                                onConfirm={modalData.onConfirm}
                                onYes={modalData.onYes}
                                onNo={modalData.onNo}
                                onClose={() => {
                                if (modalData.onClose) modalData.onClose()
                                else this.setState({ modalData: null })
                                }}
                            />
                        )}
                    </div>
                    
                </div>
            }
        </>)
	}
}

export default withTranslation()(ObjEventDetail)